/** @jsxImportSource @emotion/react */
// New Sizes
// Updated late 2025 to standardize components across all apps to fit in a "bar" by default.

export enum COMMON_SIZES {
  XSMALL = 'XSMALL',
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE'
}

export const DEFAULT_SIZE = COMMON_SIZES.MEDIUM

export const COMMON_HEIGHTS = {
  [COMMON_SIZES.XSMALL]: 20,
  [COMMON_SIZES.SMALL]: 32,
  [COMMON_SIZES.MEDIUM]: 40,
  [COMMON_SIZES.LARGE]: 56
}
